import { render, staticRenderFns } from "./add.vue?vue&type=template&id=25903bfc&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=25903bfc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25903bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25903bfc')) {
      api.createRecord('25903bfc', component.options)
    } else {
      api.reload('25903bfc', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=25903bfc&scoped=true", function () {
      api.rerender('25903bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/convalescenceSystem/convalescenceManagement/add.vue"
export default component.exports